<template lang="pug">
  v-container(fluid)
    Search(:tickets="tickets" :title="title" :loading="loading")
</template>

<script>
import ticketService from '../service.js'
import Search from '../components/SearchList'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      tickets: [],
      title: null,
      loading: true
    }
  },
  components: {
    Search
  },
  computed: {
    ...mapGetters('global', ['search'])
  },
  watch: {
    search(val) {
      this.searchInTicket(val)
    }
  },
  created() {
    // if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location")
    this.searchInTicket(this.search)
  },
  methods: {
    searchInTicket(val) {
      // if (!this.$route.params) return this.$router.push("/location")
      this.title = this.search
      this.loading = true
      ticketService.searchInTicket({search: val})
      .then(result => {
        this.tickets = result.data
        this.loading = false
      })
    }
   
  }
}
</script>

<style scoped>
</style>